/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf12.png';

const RoeStep3 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="ROE"
    hideAlert={true}
    subTitle="Return on Investments"
    paragraph1={(
      <Fragment>
        Investors expect a minimum return on their investments.
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        It's a key reason why Warren Buffet, one of the most successful investors in the world,
        passed on Japan's private sector in the '90s: their return on equity was on of the lowest
        within the developed world.<br />
        Times have changed since <a href="https://www.youtube.com/watch?v=P55HPJAH_v0" rel="noreferrer" target="_blank">Warren Buffett's famous 1998 speech on investing in Japan</a>.
        Japanese companies are generating higher ROE and Buffet recently made sizable investments in Japan's private sector.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default RoeStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/roe/step3.js